import { render, staticRenderFns } from "./ChannelItem.vue?vue&type=template&id=177c81f4&scoped=true&"
import script from "./ChannelItem.vue?vue&type=script&lang=js&"
export * from "./ChannelItem.vue?vue&type=script&lang=js&"
import style0 from "./ChannelItem.vue?vue&type=style&index=0&id=177c81f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177c81f4",
  null
  
)

export default component.exports